'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _index = require('../index');

var _SubscriptionCell = require('./SubscriptionCell.scss');var styles = _interopRequireWildcard(_SubscriptionCell);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var SubscriptionCell = function SubscriptionCell(props) {var _cx;var
  ids = props.ids,name = props.name,translate = props.translate,onChange = props.onChange,status = props.status,isMobile = props.isMobile;

  var handleSwitchChange = function handleSwitchChange(checked) {
    onChange(ids, checked);
  };

  var handleStatusCell = function handleStatusCell(evt) {
    evt.stopPropagation();
  };

  return (
    _react2.default.createElement('div', { className: styles.subscriptionCell },
      _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.name, (_cx = {}, _cx[styles.mobileName] = isMobile, _cx)) }, translate('mySubscriptions', name)),
      _react2.default.createElement('div', { className: styles.toggleStatus, onClick: handleStatusCell },
        _react2.default.createElement(_index.OMSwitch, {
          id: 'subscription-switch',
          label: translate('mySubscriptions', status ? 'enable' : 'disable').toString(),
          onChange: handleSwitchChange,
          isChecked: !!status }))));




}; // Styles

SubscriptionCell.propTypes = {
  translate: _propTypes2.default.func.isRequired,
  ids: _propTypes2.default.array,
  name: _propTypes2.default.string,
  status: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool };exports.default =


SubscriptionCell;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SubscriptionCell/SubscriptionCell.js
// module id = 2888
// module chunks = 0